


















































































































































































































































































































































import BaseDialog from '@/components/BaseDialog.vue';
import VExtendedDataPicker from '@/components/VExtendedDataPicker.vue';
import AudioPlayerBtn from '@/components/media/AudioPlayerBtn.vue';
import CopyStakeAutoclickerPromptsModal from '@/views/CopyStake/CopyStakeAutoclicker/AiStreamers/CopyStakeAutoclickerPromptsModal.vue';

import { PropType } from 'vue';
import {
  IStreamerListResponse,
  TAutoclickerCountryRecord,
  TAutoclickerAvatarRecord,
  TAutoclickerVoiceRecord,
  TAutoclickerGameData,
  TAutoclickerTemplate,
  TStreamer,
  ValidationRules,
  TAutoclickerScriptRecord,
  EStreamingType,
  EStreamingModerationStages,
  TCopyStakeSettingsBetVolumesResponse
} from '@/api/schema';
import * as vr from '@/helpers/validation';
import { getStreamersList } from '@/api/CopyStake/Streamers';
import { AxiosError } from 'axios';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { mapGetters } from 'vuex';
import { getBetVolumesConfiguration } from '@/api/CopyStake/Settings';
import { DateTime } from 'luxon';
import {
  TAutoClicker,
  TIMEZONES
} from '@/views/CopyStake/CopyStakeAutoclicker/types';
import {
  createAutoclickerConfig,
  getAutoclickerCountriesList,
  getAutoclickerAvatarsList,
  getAutoclickerVoicesList,
  getAutoclickerTemplates,
  updateAutoclickerConfig,
  getAutoclickerScriptList
} from '@/api/CopyStake/AutoClicker';

import { textOverflowMiddle, truncateString } from '@/helpers/formatString';
import { getLangCode } from '@/helpers/langHelpers';
import { cloneDeep } from 'lodash';

const DEFAULT_BET_AMOUNT = 0.5;
const DEFAULT_CURRENCY = 'USD';
const DEFAULT_ZONE = 'UTC';

export const NO_AVATAR_ID = 'NO_AVATAR';

const defaultFormData = (): Partial<TAutoClicker> => {
  return {
    id: null,
    streamerId: '',
    supportedGameIds: [],
    defaultBetAmount: DEFAULT_BET_AMOUNT,
    currency: DEFAULT_CURRENCY,
    scenarioTemplateId: '',
    startTime: '',
    endTime: '',
    zone: DEFAULT_ZONE,
    login: '',
    password: '',
    countryId: '',
    baseScriptId: '',
    heygenAvatarId: '',
    heygenVoiceId: '',
    voiceLanguage: ''
  };
};

export default {
  name: 'CopyStakeAutoclickerEditModal',
  components: {
    CopyStakeAutoclickerPromptsModal,
    AudioPlayerBtn,
    BaseDialog,
    VExtendedDataPicker
  },
  props: {
    form: {
      type: Object as PropType<Partial<TAutoClicker>>,
      default: defaultFormData
    },
    games: {
      type: Array as PropType<TAutoclickerGameData[]>,
      default: (): TAutoclickerGameData[] => []
    },
    value: {
      type: Boolean as PropType<boolean>,
      default: (): boolean => false
    }
  },
  data(): any {
    return {
      formData: defaultFormData(),
      isFormValid: true,
      currencyList: [DEFAULT_CURRENCY],
      streamersList: null,
      scenarioList: [],
      countriesList: [],
      promptsList: [],
      avatarsList: [],
      voicesList: [],
      timezoneList: TIMEZONES,
      showPassword: true,
      isShowPromptsModal: false,
      promptEditData: null,
      loading: {
        loadStreamers: false,
        configuration: false,
        templates: false,
        countries: false,
        prompts: false,
        avatars: false,
        voices: false,
        processing: false
      }
    };
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),

    formPayload(): TAutoClicker {
      return {
        ...this.formData,
        startTime: this.formData.startTime + ':00',
        endTime: this.formData.endTime + ':00'
      };
    },

    isNewConfig(): boolean {
      return !this.formData.id;
    },
    isLoading(): boolean {
      return Object.values(this.loading).some(Boolean);
    },

    currentVoiceLanguagesList(): any[] {
      const selectedVoice = this.voicesList.find(
        (voice: TAutoclickerVoiceRecord) =>
          voice.heygenVoiceId === this.formData?.heygenVoiceId
      );

      if (!selectedVoice) {
        return [];
      }

      const voiceLanguages = Object.entries(selectedVoice.voicePreviews).map(
        ([language, voicePreviewUrl]) => ({
          language: language,
          voicePreviewUrl: voicePreviewUrl || null,
          languageCode: getLangCode(language)
        })
      );

      return voiceLanguages.sort((a, b) => {
        if (a.language === 'English') return -1;
        if (b.language === 'English') return 1;
        return a.language.localeCompare(b.language);
      });
    },

    currentAvatarPreviewUrl(): string | null {
      return (
        this.avatarsList?.find(
          ({ heygenAvatarId }) =>
            heygenAvatarId === this.formData?.heygenAvatarId
        )?.imageUrl || require('@/assets/images/autoclicker-avatar.png')
      );
    },

    currentVoicePreviewUrl(): string | null {
      return (
        this.currentVoiceLanguagesList?.find(
          ({ language }) => language === this.formData?.voiceLanguage
        )?.voicePreviewUrl || null
      );
    },

    rules(): ValidationRules {
      return {
        streamerId: [(v: string) => vr.required(v, 'Streamer')],
        avatarId: [(v: string) => vr.required(v, 'Avatar')],
        voice: [(v: string) => vr.required(v, 'Voice')],
        voiceLanguage: [(v: string) => vr.required(v, 'Language')],
        supportedGameIds: [
          (v: any) => (v && v.length > 0) || 'Game is required'
        ],
        defaultBetAmount: [
          (v: string) => vr.required(v, 'Default Bet Amount'),
          vr.positiveNumber
        ],
        startTime: [
          (v: string) => vr.required(v, 'Start Time'),
          (v) => {
            const nowUtc = DateTime.now()
              .setZone(this.formData.zone)
              .toFormat('yyyy-MM-dd HH:mm');

            const isValid =
              vr.isDateTimeAfterOrEqual(v, nowUtc) === true &&
              vr.isDateNotEqual(v, nowUtc) === true;

            return isValid === true
              ? true
              : 'Start date must be in the future';
          }
        ],
        endTime: [
          (v: string) => vr.required(v, 'End Time'),
          (v) => vr.isDateNotEqual(v, this.formData.startTime),
          (v) => vr.isDateTimeAfterOrEqual(v, this.formData.startTime)
        ],
        country: [(v: string) => vr.required(v, 'Proxy')],
        prompts: [(v: string) => vr.required(v, 'AI Streamer Script')],
        zone: [(v: string) => vr.required(v, 'Timezone')],
        login: [(v: string) => vr.required(v, 'Login')],
        password: [(v: string) => vr.required(v, 'Password')],
        scenario: [(v: string) => vr.required(v, 'AI Avatar behaviour')]
      };
    }
  },
  watch: {
    async value(open: boolean): Promise<void> {
      await this.resetForm();

      if (!open) {
        return;
      }

      this.formData = {
        ...this.form,
        startTime: this.form?.startTime?.slice(0, 16),
        endTime: this.form?.endTime.slice(0, 16)
      };

      if (this.form.supportedGameIds && this.form.supportedGameIds.length) {
        const availableIds = new Set(
          (this.games || []).map((g: TAutoclickerGameData) => g.id)
        );
        this.formData.supportedGameIds = this.form.supportedGameIds.filter(
          (id: number) => availableIds.has(id)
        );
      }

      if (!this.isNewConfig) {
        this.showPassword = false;
      }

      if (!this.streamersList) {
        this.getStreamersData();
      }

      if (!this.scenarioList.length) {
        this.getTemplates();
      }

      if (this.currencyList.length <= 1) {
        this.getConfiguration();
      }

      if (this.countriesList.length <= 1) {
        this.getCountries();
      }

      if (this.avatarsList.length <= 1) {
        this.getAvatars();
      } else {
        this.setPredefinedAvatar();
      }

      if (this.voicesList.length <= 1) {
        this.getVoices();
      } else {
        this.setPredefinedVoice();
      }
    },
    'formData.zone'(): void {
      this.validateDate('startTime');
      this.validateDate('endTime');
    },
    'formData.startTime'(): void {
      this.validateDate('endTime');
    },
    'formData.endTime'(): void {
      this.validateDate('startTime');
    },
    async 'formData.voiceLanguage'(): Promise<void> {
      await this.getPrompts();

      this.setDefaultPrompt();
    }
  },
  methods: {
    async getConfiguration(): Promise<void> {
      if (!this.operatorId) {
        return;
      }

      this.loading.configuration = true;

      getBetVolumesConfiguration()
        .then((data: TCopyStakeSettingsBetVolumesResponse) => {
          if (data) {
            this.currencyList = Object.keys(data);
          }
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.loading.configuration = false;
        });
    },
    async getTemplates(): Promise<void> {
      this.loading.templates = true;

      getAutoclickerTemplates()
        .then((data: TAutoclickerTemplate[]): void => {
          this.scenarioList = data;
        })
        .catch(() => {
          this.scenarioList = [];
        })
        .finally(() => {
          this.loading.templates = false;
        });
    },
    async getCountries(): Promise<void> {
      this.loading.countries = true;

      getAutoclickerCountriesList()
        .then((data: TAutoclickerCountryRecord[]): void => {
          this.countriesList = data;
        })
        .catch(() => {
          this.countriesList = [];
        })
        .finally(() => {
          this.loading.countries = false;
        });
    },
    async getPrompts(id: number): Promise<void> {
      if (!this.formData.voiceLanguage) return;

      this.loading.prompts = true;

      return getAutoclickerScriptList(this.formData.voiceLanguage)
        .then((data: TAutoclickerScriptRecord[]): void => {
          this.promptsList = data;

          if (id) this.formData.baseScriptId = id;
        })
        .catch(() => {
          this.promptsList = [];
        })
        .finally(() => {
          this.loading.prompts = false;
        });
    },
    async getAvatars(): Promise<void> {
      this.loading.avatars = true;

      getAutoclickerAvatarsList()
        .then((data: TAutoclickerAvatarRecord[]): void => {
          this.avatarsList = data.sort((a, b) =>
            a.avatarName.localeCompare(b.avatarName)
          );

          this.setPredefinedAvatar();
        })
        .catch(() => {
          this.avatarsList = [];
        })
        .finally(() => {
          this.loading.avatars = false;
        });
    },
    async getVoices(): Promise<void> {
      this.loading.voices = true;

      getAutoclickerVoicesList()
        .then((data: TAutoclickerVoiceRecord[]): void => {
          this.voicesList = data || [];

          this.setPredefinedVoice();
        })
        .catch(() => {
          this.voicesList = [];
        })
        .finally(() => {
          this.loading.voices = false;
        });
    },

    async resetForm(): Promise<void> {
      await this.$refs.form?.reset();

      this.formData = { ...this.formData, ...defaultFormData() };
    },

    async handleSubmit(): Promise<void> {
      await this.$refs.form.validate();

      if (!this.isFormValid || this.loading.processing) return;

      this.loading.processing = true;

      if (this.isNewConfig) {
        createAutoclickerConfig(this.formPayload)
          .then(() => {
            this.$toast.success('AutoClicker Config created');
            this.$emit('update');
            this.closeModal();
          })
          .catch(errorToastMessage)
          .finally(() => {
            this.loading.processing = false;
          });
      } else {
        updateAutoclickerConfig(this.formPayload)
          .then(() => {
            this.$toast.success('AutoClicker Config updated');
            this.$emit('update');
            this.closeModal();
          })
          .catch(errorToastMessage)
          .finally(() => {
            this.loading.processing = false;
          });
      }
    },

    async getStreamersData(): Promise<void> {
      if (!this.operatorId) return;

      this.loading.loadStreamers = true;

      getStreamersList({
        size: 1000,
        page: 0,
        operatorId: this.operatorId,
        streamingType: EStreamingType.WEB,
        moderationStages: [
          EStreamingModerationStages.ACCEPTED,
          EStreamingModerationStages.COMPLETED
        ]
      })
        .then((data: IStreamerListResponse) => {
          this.streamersList = data.content
            .filter(({ nickname }) => !!nickname)
            .map(({ nickname, id }: TStreamer) => ({
              text: nickname,
              value: id
            }));
        })
        .catch((error: AxiosError): void => {
          errorToastMessage(error);
        })
        .finally(() => {
          this.loading.loadStreamers = false;
        });
    },

    setPredefinedAvatar(): void {
      if (
        this.isNewConfig &&
        this.avatarsList.length &&
        !this.formData.heygenAvatarId
      ) {
        this.formData.heygenAvatarId =
          this.avatarsList[0]?.heygenAvatarId || null;
      }
    },
    setPredefinedVoice(): void {
      if (!this.voicesList.length) return;

      if (this.isNewConfig && !this.formData.heygenVoiceId) {
        this.formData.heygenVoiceId =
          this.voicesList[0]?.heygenVoiceId || null;

        this.formData.voiceLanguage =
          this.currentVoiceLanguagesList[0]?.language || null;
      } else {
        const originalHeygenVoiceId = this.voicesList?.find(
          (voice: TAutoclickerVoiceRecord) =>
            (this.form?.heygenAvatarId === NO_AVATAR_ID
              ? voice.elevenlabVoiceId
              : voice.heygenVoiceId) === this.form?.heygenVoiceId
        )?.heygenVoiceId;

        this.formData.heygenVoiceId = originalHeygenVoiceId || '';
      }
    },
    changeHeygenVoice(): void {
      const languageExists = this.currentVoiceLanguagesList.some(
        (item) => item.language === this.formData.voiceLanguage
      );

      if (!languageExists) {
        this.formData.voiceLanguage =
          this.currentVoiceLanguagesList[0]?.language || '';
      }
    },

    setDefaultPrompt(): void {
      if (
        (!this.isNewConfig && !this.formData.baseScriptId) ||
        !this.promptsList?.length
      ) {
        this.formData.baseScriptId = null;

        return;
      }

      const hasFormBaseId = !!this.form?.baseScriptId;
      if (hasFormBaseId) {
        const found = this.promptsList.find(
          (script: TAutoclickerScriptRecord) =>
            script.id === this.form.baseScriptId
        );
        if (found) {
          this.formData.baseScriptId = found.id;
          this.$nextTick(() => {
            this.$refs.promptsInput?.validate();
          });
          return;
        }
      }

      const systemPrompt = this.promptsList.find(
        (script: TAutoclickerScriptRecord) => script.isSystem
      );
      this.formData.baseScriptId = systemPrompt ? systemPrompt.id : null;
      this.$nextTick(() => {
        this.$refs.promptsInput?.validate();
      });
    },
    addNewPromptsHandler(): void {
      this.promptEditData = null;
      this.isShowPromptsModal = true;
    },
    copyPromptsHandler(item: TAutoclickerScriptRecord): void {
      this.$refs.promptsInput.isMenuActive = false;

      this.promptEditData = {
        ...cloneDeep(item),
        id: null,
        name: item.name + ' - Copy'
      };
      this.isShowPromptsModal = true;
    },
    editPromptsHandler(item: TAutoclickerScriptRecord): void {
      this.$refs.promptsInput.isMenuActive = false;

      this.promptEditData = cloneDeep(item);
      this.isShowPromptsModal = true;
    },

    removeGameItem({ id }: { id: number }): void {
      this.formData.supportedGameIds = this.formData.supportedGameIds.filter(
        (gameId: number) => gameId !== id
      );
    },

    closeModal(): void {
      this.$emit('input', false);
    },

    validateDate(type: string): void {
      if (this.formData[type]?.length !== 0) {
        this.$refs[type].validate();
      }
    },

    truncateString,
    textOverflowMiddle
  }
};
